import { createSlice } from "@reduxjs/toolkit";
import { SubscribeNewsAPI } from "../../services/subscribe-news";

const SubscribeNews = createSlice({
  name: "Subscribe news",
  initialState: {
    subscribers: [],
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(SubscribeNewsAPI.getAll.fulfilled, (state, action) => {
      const { total, subscribes } = action.payload;

      state.total = total;
      state.subscribers = subscribes;
    });
  },
});

export default SubscribeNews;
